import { compose } from "redux";
import classNames from "classnames";
import React, { PureComponent, createRef } from "react";
import { Grid, Typography, withStyles } from "@material-ui/core";

import { Format } from "app/app.constants";
import { formatDate } from "utils/format.util";
import {
  SHIFT_TYPES,
  CALENDAR_DATE_RANGE_TYPE,
} from "features/planner/planner.constants";
import { workScheduleOverrideReasonToString } from "features/planner/planner.mappers";

class WorkScheduleReportSchedulePeriod extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      height: undefined,
    };

    this.root = createRef();
  }

  componentDidMount() {
    this.setState({
      height: this.root.current ? this.root.current.clientHeight : undefined,
    });
  }

  render() {
    const { classes, schedulePeriod } = this.props;

    const startDate = formatDate(
      schedulePeriod.get("startDate"),
      Format.workSchedule,
    );

    const endDate = formatDate(
      schedulePeriod.get("endDate"),
      Format.workSchedule,
    );

    const isDeployment =
      schedulePeriod.get("schedulePeriodType") ===
      CALENDAR_DATE_RANGE_TYPE.DEPLOYMENT;

    const isOverride =
      schedulePeriod.get("schedulePeriodType") ===
      CALENDAR_DATE_RANGE_TYPE.AVAILABILITY_OVERRIDE;

    const name = isOverride
      ? workScheduleOverrideReasonToString(schedulePeriod.get("overrideReason"))
      : schedulePeriod.get("name");

    return (
      <Grid
        xs
        item
        ref={this.root}
        title={`${startDate} - ${endDate}`}
        className={classNames(classes.schedulePeriod, {
          [classes.deployment]: isDeployment,
          [classes.scheduleOverride]: isOverride,
        })}
      >
        <Typography
          noWrap
          variant="caption"
          color="secondary"
          className={classNames(classes.schedulePeriodTitle, {
            [classes[
              `deploymentShiftType-${schedulePeriod.get("shiftType")}`
            ]]: isDeployment,
          })}
          style={{
            fontSize: this.state.height
              ? Math.min(12, this.state.height - 1)
              : undefined,
          }}
        >
          {name}
        </Typography>
      </Grid>
    );
  }
}

const styles = theme => ({
  schedulePeriod: {
    display: "flex",
    marginBottom: 1,
    borderRadius: 2,
    maxHeight: "35%",
    cursor: "default",
    alignItems: "center",
    position: "absolute",
    justifyContent: "center",
    left: ({ left }) => left,
    right: ({ right }) => right,
    height: ({ height }) => height,
    padding: `0 ${theme.spacing(0.5)}px`,
    transform: ({ transform }) => transform,
  },
  schedulePeriodTitle: {
    fontSize: "0.7rem",
    lineHeight: "100%",
    fontWeight: theme.typography.fontWeightMedium,
  },
  deployment: {
    background: theme.altus.calendar.deploymentColor.main,
    "&:hover": {
      background: theme.altus.calendar.deploymentColor.hover,
    },
  },
  scheduleOverride: ({ schedulePeriod }) => ({
    fontWeight: theme.typography.fontWeightBold,
    ...theme.mixins.workScheduleOverride(schedulePeriod.get("overrideReason")),
  }),
  [`deploymentShiftType-${SHIFT_TYPES.DAY}`]: {
    fontWeight: theme.typography.fontWeightBold,
  },
  [`deploymentShiftType-${SHIFT_TYPES.MID}`]: {
    fontWeight: theme.typography.fontWeightRegular,
    fontStyle: "italic",
  },
});

export default compose(withStyles(styles))(WorkScheduleReportSchedulePeriod);
